import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { FoundationalPremise } from '../components/sections/FoundationalPremise';
import { NCJIFramework } from '../components/sections/NCJIFramework';
import { DevelopmentalModel } from '../components/sections/DevelopmentalModel';
import { CompetenceAuthority } from '../components/sections/CompetenceAuthority';
import { LeadershipStandards } from '../components/sections/LeadershipStandards';
import { PhilosophicalFoundation } from '../components/sections/PhilosophicalFoundation';
import { PoliticalResponse } from '../components/sections/PoliticalResponse';
import { EndState } from '../components/sections/EndState';
export function CognocracyLanding() {
  return <main className="relative w-full bg-[#060a14] overflow-hidden" data-id="element-218">
      <HeroSection data-id="element-219" />
      <FoundationalPremise data-id="element-220" />
      <NCJIFramework data-id="element-221" />
      <DevelopmentalModel data-id="element-222" />
      <CompetenceAuthority data-id="element-223" />
      <LeadershipStandards data-id="element-224" />
      <PhilosophicalFoundation data-id="element-225" />
      <PoliticalResponse data-id="element-226" />
      <EndState data-id="element-227" />
    </main>;
}